
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skiferie",
      function () {
        return require("private-next-pages/[region]/[resort]/skiferie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skiferie"])
      });
    }
  